@if (!pfUser()?.res?.mobileNumber && currentPage()?.pageId === 'profile' && visible()) {
  <section class="sanofi-infoBanner sanofi-infoBanner--addMobilePhoneInfo py-4 px-3 my-3 d-flex">
    <cx-icon class="sanofi-infoBanner__warningIcon align-self-start pr-2" [type]="iconTypes.INFO"/>
    <div class="sanofi-infoBanner__content">
      <h5 class="sanofi-infoBanner__header font-bold mb-0">{{ 'profile.phoneBanner.title' | cxTranslate }}</h5>
    </div>
    <div class="d-flex lign-self-center flex-fill justify-content-end">
      <button aria-label="close"
              tabindex="0"
              role="button"
              aria-pressed="false"
              class="sanofi-infoBanner__closeIconButton"
              (click)="visible.set(false)"
      >
        <cx-icon class="sanofi-infoBanner__closeIcon" [type]="iconTypes.CLOSE"/>
      </button>
    </div>
  </section>
}
